<template>
  <div class="loader">
    <div class="loader__container">
      <img class="loader__flower" src="/img/misc/flower.png" alt="flower">
      <p class="loader__text">
        {{ $translate('loader') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoader',
};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  @include gradient-bg(1);
  @extend %background-grain;

  z-index: 2;

  &__container {
    position: relative;
    flex: 0 0 auto;
  }

  img {
    width: 140vw;
    height: 140vw;
    margin: unset;

    @include mq(ipadP, $and: $is-not-touch-device) {
      width: 100vw;
      height: 100vw;
    }
  }

  &__flower {
    position: relative;
  }

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    color: $red;
    font-weight: normal;
  }
}
</style>
